import script from "./ShowControllerInteractionsPermissions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowControllerInteractionsPermissions.vue?vue&type=script&setup=true&lang=ts"

import "./ShowControllerInteractionsPermissions.vue?vue&type=style&index=0&id=c430a3ca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c430a3ca"]])

export default __exports__